import { ACCOMMODATIONS_DATA, ACCOMMODATIONS_DATA_SUCCESS, ACCOMMODATIONS_DATA_ERROR } from'../actions/actionTypes'

import cloneDeep from 'lodash/cloneDeep'
import defer from 'lodash/defer'

import AccommodationsDataSource from './../sources/AccommodationsDataSource'

const initialState = {
    data: [],
    loading: false
}

function reducer(state = initialState, action) {
    let nextState = cloneDeep(state)

    switch (action.type) {
        case ACCOMMODATIONS_DATA: {

            const { successCallback, errorCallback } = action

            nextState.loading = true
            AccommodationsDataSource.index(successCallback, errorCallback)
            return nextState
        }
        case ACCOMMODATIONS_DATA_SUCCESS: {

            const { data, successCallback } = action

            if(successCallback) defer(successCallback, data);

            nextState.loading = false
            nextState.data = data.accommodations_data
            return nextState
        }
        case ACCOMMODATIONS_DATA_ERROR: {

            const { error, errorCallback } = action

            if(errorCallback) defer(errorCallback, error);

            nextState.loading = false
            nextState.data = []
            return nextState
        }
        default: {
            return state
        }
    }
};

export default reducer


// WEBPACK FOOTER //
// ./src/reducers/accommodationsData.js